var exports = {
  "kL": "SimplePageSkeleton.module__container___clEtSE",
  "wx": "SimplePageSkeleton.module__header___clEtSE",
  "BU": "SimplePageSkeleton.module__headerCompact___clEtSE",
  "Kh": "SimplePageSkeleton.module__headerLeading___clEtSE",
  "$s": "SimplePageSkeleton.module__headerActions___clEtSE",
  "Ge": "SimplePageSkeleton.module__rows___clEtSE",
  "nM": "SimplePageSkeleton.module__row___clEtSE",
  "pt": "SimplePageSkeleton.module__rowDetails___clEtSE",
  "y6": "SimplePageSkeleton.module__channelGroups___clEtSE",
  "Rf": "SimplePageSkeleton.module__channelGroupHeading___clEtSE",
  "S7": "SimplePageSkeleton.module__channelCard___clEtSE",
  "Fp": "SimplePageSkeleton.module__channelCardHeader___clEtSE",
  "ut": "SimplePageSkeleton.module__channelCardStream___clEtSE",
  "P9": "SimplePageSkeleton.module__channelCardFooter___clEtSE",
  "YX": "SimplePageSkeleton.module__tableContent___clEtSE",
  "KE": "SimplePageSkeleton.module__toolbar___clEtSE",
  "d0": "SimplePageSkeleton.module__toolbarLeft___clEtSE",
  "O5": "SimplePageSkeleton.module__toolbarRight___clEtSE",
  "wY": "SimplePageSkeleton.module__tableWrapper___clEtSE",
  "p": "SimplePageSkeleton.module__tableViewport___clEtSE",
  "uV": "SimplePageSkeleton.module__tableSurface___clEtSE",
  "QS": "SimplePageSkeleton.module__tableSurfaceSelectable___clEtSE",
  "iA": "SimplePageSkeleton.module__tableFooter___clEtSE",
  "vl": "SimplePageSkeleton.module__tableFooterLeft___clEtSE",
  "C5": "SimplePageSkeleton.module__tableFooterRight___clEtSE",
  "tT": "SimplePageSkeleton.module__tableHeadRow___clEtSE",
  "ts": "SimplePageSkeleton.module__tableHeadCell___clEtSE",
  "bg": "SimplePageSkeleton.module__tableBody___clEtSE",
  "jD": "SimplePageSkeleton.module__tableRow___clEtSE",
  "xR": "SimplePageSkeleton.module__tableCell___clEtSE",
  "MN": "SimplePageSkeleton.module__tableNameCell___clEtSE",
  "mg": "SimplePageSkeleton.module__tableNameInfo___clEtSE",
  "Yo": "SimplePageSkeleton.module__tableActionsCell___clEtSE",
};

module.exports = exports;
